import { parseUtcTimestamp, safeFormatDate } from '@utils/date';

/** «сегодня, 21:10» / «вчера, 09:03» / «12.09.2026 18:40». */
export const formatDraftWhen = (raw: string | null | undefined): string => {
    const date = parseUtcTimestamp(raw);
    if (!date) return '';
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    if (date.toDateString() === now.toDateString()) return `сегодня, ${safeFormatDate(date, 'HH:mm')}`;
    if (date.toDateString() === yesterday.toDateString()) return `вчера, ${safeFormatDate(date, 'HH:mm')}`;
    return safeFormatDate(date, 'DD.MM.YYYY HH:mm');
};
